class s{constructor(){this.enabled=!0}}export{s as RigidBodyComponentData};
